import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { SideNavModule } from '../side-nav/side-nav.module';
import { HeaderModule } from './../header/header.module';
import { PageContentModule } from './../page-content/page-content.module';
import { AppShellComponent } from './app-shell.component';


@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FlexModule,
    HeaderModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTooltipModule,
    PageContentModule,
    RouterModule,
    SideNavModule,
  ],
  declarations: [AppShellComponent],
  exports: [AppShellComponent]
})
export class AppShellModule { }
